import { Share2, Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function LinkedInShareButton({ 
  title, 
  summary, 
  url = window.location.href,
  variant = "default",
  size = "default",
  className = ""
}) {
  const handleShare = () => {
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    
    // Open LinkedIn share dialog
    const width = 600;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    
    window.open(
      shareUrl,
      'linkedin-share',
      `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0`
    );
    
    toast.success("Відкрито LinkedIn для шерингу!");
  };

  return (
    <Button
      onClick={handleShare}
      variant={variant}
      size={size}
      className={`${className} flex items-center space-x-2`}
      data-testid="linkedin-share-button"
    >
      <Linkedin className="w-4 h-4" />
      <span>Поділитися в LinkedIn</span>
    </Button>
  );
}

export function ShareCard({ children, onClick }) {
  return (
    <div
      onClick={onClick}
      className="bg-card/50 backdrop-blur-sm border border-white/5 p-6 rounded-xl hover:border-primary/30 transition-all cursor-pointer group"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">{children}</div>
        <Share2 className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
      </div>
    </div>
  );
}
